import React from 'react';

import cx from 'classnames';
import { SocialMediaLinks } from 'themes/common/components/NavItemSocial/SocialMediaLinks';

import Button from 'components/Button';

import { TProfessional } from 'types/appointment';

import s from './ClassicTeamMember.module.css';

type TMemberProps = {
  professional: TProfessional;
  onClick: (professional: TProfessional) => void;
};

const ClassicTeamMember = ({ professional, onClick }: TMemberProps) => {
  const handleClick = () => onClick(professional);

  const isBookingEnabled =
    professional.available_for_booking &&
    professional.assigned_services.length > 0;

  const socialLinks = {
    instagram_url: professional.instagram_url,
    facebook_url: professional.facebook_url,
    twitter_url: professional.twitter_url,
    yelp_url: professional.yelp_url,
    website_url: professional.website_url,
    pinterest_url: professional.pinterest_url,
  };

  return (
    <div className={cx(s.root)}>
      <div className={s.header}>
        <img
          className={s.image}
          src={professional.avatar_original}
          alt={professional.full_name}
        />
      </div>
      <div className={s.main}>
        <h2 className={s.title}>{professional.full_name}</h2>
        <p className={cx(s.summary)}>{professional.about}</p>
        <SocialMediaLinks className={s.socialLinks} urls={socialLinks} />
        {isBookingEnabled && (
          <Button className={s.button} onClick={handleClick}>
            Book
          </Button>
        )}
      </div>
    </div>
  );
};

export { ClassicTeamMember };
